// Author YuJiaBei
// Date 2021-09-08 11:21:38

class SithMesMstLocation {
constructor({
        id = null,
        code = '',
        parentId = '',
        parentName = '',
        name = '',
        machineCode = '',
        machineType = '',
        standWorkHour = '',
        manCount = '',
        seq = '',
        externalId = '',
        remark = ''}
= {}) {
    this.id = id;
    this.code = code;
    this.parentId = parentId;
    this.parentName = parentName;
    this.name = name;
    this.machineCode = machineCode;
    this.machineType = machineType;
    this.standWorkHour = standWorkHour;
    this.manCount = manCount;
    this.seq = seq;
    this.externalId = externalId;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstLocation();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstLocation.grid.code',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentId',
        label: 'label.sith.mst.sithMesMstLocation.grid.parentId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentName',
        label: 'label.sith.mst.sithMesMstLocation.grid.parentName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'parentMachineType',
        label: 'label.sith.mst.sithMesMstLocation.grid.parentMachineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'machine-工作中心' },
                            { value: '2', text: 'man-工作中心' },
                            { value: '3', text: 'virtual' },
                            { value: '4', text: '公司' },
                            { value: '5', text: '部门' },
                            { value: '6', text: '成本中心' },
                            { value: '7', text: '工位' }
            ]
        }
        },
        {
        key: 'level',
        label: 'label.sith.mst.sithMesMstLocation.grid.level',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'nodeCode',
        label: 'label.sith.mst.sithMesMstLocation.grid.nodeCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstLocation.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineCode',
        label: 'label.sith.mst.sithMesMstLocation.grid.machineCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'machineType',
        label: 'label.sith.mst.sithMesMstLocation.grid.machineType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: 'machine-工作中心' },
                            { value: '2', text: 'man-工作中心' },
                            { value: '3', text: 'virtual' },
                            { value: '4', text: '公司' },
                            { value: '5', text: '部门' },
                            { value: '6', text: '成本中心' },
                            { value: '7', text: '工位' }
            ]
        }
        },
        {
        key: 'standWorkHour',
        label: 'label.sith.mst.sithMesMstLocation.grid.standWorkHour',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'manCount',
        label: 'label.sith.mst.sithMesMstLocation.grid.manCount',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.mst.sithMesMstLocation.grid.seq',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'externalId',
        label: 'label.sith.mst.sithMesMstLocation.grid.externalId',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocation.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    codeFilter : "",
    parentIdFilter : "",
    parentNameFilter : "",
    levelFilter : "",
    nodeCodeFilter : "",
    nameFilter : "",
    machineCodeFilter : "",
    machineTypeFilter : "",
    standWorkHourFilter : "",
    manCountFilter : "",
    externalIdFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'codeFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.code',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentNameFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.parentName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineCodeFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.machineCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineTypeFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.machineType',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: 'machine-工作中心' },
                { value: '2', text: 'man-工作中心' },
                { value: '3', text: 'virtual' },
                { value: '4', text: '公司' },
                { value: '5', text: '部门' },
                { value: '6', text: '成本中心' },
                { value: '7', text: '工位' }
            ]
        }
        },
        {
        key: 'standWorkHourFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.standWorkHour',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'manCountFilter',
        label: 'label.sith.mst.sithMesMstLocation.filter.manCount',
        disabled: false,
        form: {
        type: 'input'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'code',
        label: 'label.sith.mst.sithMesMstLocation.entity.code',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'parentName',
        label: 'label.sith.mst.sithMesMstLocation.entity.parentName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'sithMesMstLocation'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"parentId":"id"}'
                }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstLocation.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'machineCode',
        label: 'label.sith.mst.sithMesMstLocation.entity.machineCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'machineType',
        label: 'label.sith.mst.sithMesMstLocation.entity.machineType',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: 'machine-工作中心' },
                { value: '2', text: 'man-工作中心' },
                { value: '3', text: 'virtual' },
                { value: '4', text: '公司' },
                { value: '5', text: '部门' },
                { value: '6', text: '成本中心' },
                { value: '7', text: '工位' }
            ]
        }
        },
        {
        key: 'standWorkHour',
        label: 'label.sith.mst.sithMesMstLocation.entity.standWorkHour',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'manCount',
        label: 'label.sith.mst.sithMesMstLocation.entity.manCount',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.mst.sithMesMstLocation.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstLocation.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstLocation, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
